import { Button, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody, Text, Box, Input, Textarea } from "@chakra-ui/react"
import { useDispatch, useSelector } from "react-redux"
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { reportMessage, reportMissingStation, reportUnmappedRoute, reset } from "../features/userReports/userReportSlice"


export default function UserReportPopover({ children, type, journeyId, routerRequestLogRecordId }) {

    const { isLoading, isError, isSuccess } = useSelector((state) => state.userReports)

    const dispatch = useDispatch()

    const formik = useFormik({
        initialValues: {
            name: '',
            country: '',
            additionalInfo: '',
        },
        onSubmit: (values) => {
            switch (type) {
                case 'unmappedRoute':
                    if (!journeyId && !routerRequestLogRecordId) {
                        return
                    }

                    dispatch(reportUnmappedRoute({
                        journeyId: journeyId ? journeyId : undefined,
                        routerRequestLogRecordId: routerRequestLogRecordId ? routerRequestLogRecordId : undefined,
                    }))
                    break;
                case 'missingStation':
                    dispatch(reportMissingStation({ stationDetails: values }))
                    break;
                case 'message':
                    dispatch(reportMessage({messageDetails: values.additionalInfo}))
                default:
                    break;
            }
        },
    })

    return (
        <Popover placement="top" onClose={() => dispatch(reset())}>
            <PopoverTrigger>
                {children}
            </PopoverTrigger>
            <PopoverContent maxW='300px' whiteSpace="normal">
                <PopoverArrow />
                <PopoverCloseButton />
                {type === 'unmappedRoute' && (<PopoverHeader fontSize="lg" fontWeight="bold">Unable to find route</PopoverHeader>)}
                {type === 'missingStation' && (<PopoverHeader fontSize="lg" fontWeight="bold">Missing station</PopoverHeader>)}
                {type === 'message' && (<PopoverHeader fontSize="lg" fontWeight="bold">Report a bug or provide a suggestion</PopoverHeader>)}
                <PopoverBody>
                    <form onSubmit={formik.handleSubmit}>
                        {type === 'unmappedRoute' && (<>
                            <Text mb={2}>Please check if the origin, destination, and via points are correct.</Text>
                            <Text mb={2}>If they are correct, please provide as much information as possible about the route so we can investigate & fix the issue.</Text>
                            {!journeyId && (
                                <Text mb={4}>If added, the journey will appear on the map as a blurred line.</Text>
                            )}
                        </>)}

                        {type === 'missingStation' && (
                            <>
                                <Text mb={2}>Please provide as much information as possible about the missing station.</Text>
                                <Input
                                    name="name"
                                    placeholder="Station name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    isInvalid={formik.touched.name && formik.errors.name}
                                />
                                <Input
                                    name="country"
                                    placeholder="Country"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.country}
                                    isInvalid={formik.touched.country && formik.errors.country}
                                />
                                <Input
                                    name="additionalInfo"
                                    placeholder="Additional information (e.g. Google Maps/OSM or public authority website link)"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.additionalInfo}
                                />
                            </>
                        )}
                        {type === 'message' && (
                            <>
                                <Text mb={2}>Provide information about the bug or suggestion. We will follow up by email. Thank you for helping improve TrainLookout!</Text>
                                <Textarea
                                    name="additionalInfo"
                                    placeholder="Description"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.additionalInfo}
                                    isDisabled={isError || isSuccess}
                                />
                            </>
                        )}
                        <Button
                            onClick={formik.handleSubmit}
                            isLoading={isLoading}
                            isDisabled={isError || isSuccess}
                            colorScheme="blue"
                        >
                            Report
                        </Button>
                    </form>

                    {isSuccess && <Text color="green.500">Successfully reported. We will provide an update by email.</Text>}
                    {isError && <Text color="red.500">Error trying to report. Refresh & try again or email hello@trainlookout.com</Text>}
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}